import { render, staticRenderFns } from "./DialogUpdateTeams.vue?vue&type=template&id=70bbc8a2&scoped=true&"
import script from "./DialogUpdateTeams.vue?vue&type=script&lang=js&"
export * from "./DialogUpdateTeams.vue?vue&type=script&lang=js&"
import style0 from "./DialogUpdateTeams.vue?vue&type=style&index=0&id=70bbc8a2&lang=scss&scoped=true&"
import style1 from "./DialogUpdateTeams.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bbc8a2",
  null
  
)

export default component.exports